(function () {
  if (window.junisFetch) return;
  window.junisFetch = function (url, opts) {
    opts = opts || {};
    var timeout = opts.junisTimeout || 8000;
    var retries = opts.junisRetries || 0;
    var base = {};
    for (var k in opts) {
      if (k !== 'junisTimeout' && k !== 'junisRetries') base[k] = opts[k];
    }
    function attempt(n) {
      var o = {};
      for (var bk in base) o[bk] = base[bk];
      if (!o.signal && typeof AbortSignal !== 'undefined' && AbortSignal.timeout) {
        o.signal = AbortSignal.timeout(timeout);
      }
      return fetch(url, o)
        .then(function (r) {
          if (!r.ok && r.status >= 500 && n < retries) throw new Error('junisFetch retry ' + r.status);
          return r;
        })
        .catch(function (err) {
          if (n < retries) {
            return new Promise(function (res) { setTimeout(res, 600 * (n + 1)); }).then(function () {
              return attempt(n + 1);
            });
          }
          throw err;
        });
    }
    return attempt(0);
  };
})();
